// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bea_a bhs_cw bhs_jx bhs_jo bhs_rh bhs_vf"};